import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Avatar,
  Stack,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import GroupsIcon from '@mui/icons-material/Groups';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import logo from '../../../Assets/azul.png';

const InicioLanding = () => {
  const navigate = useNavigate();

  const cardVariants = {
    hiddenLeft: { opacity: 0, x: -100 },
    hiddenRight: { opacity: 0, x: 100 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
        delay: i * 0.2,
      },
    }),
  };

  const tarjetas = [
    {
      titulo: 'Entrenamientos',
      path: '/entrenamientos',
      icono: <FitnessCenterIcon sx={{ fontSize: 30 }} />,
      variante: 'hiddenLeft',
    },
    {
      titulo: 'Ligas',
      path: '/ligas',
      icono: <SportsSoccerIcon sx={{ fontSize: 30 }} />,
      variante: 'hiddenRight',
    },
    {
      titulo: 'Jugadores',
      path: '/jugadores',
      icono: <GroupsIcon sx={{ fontSize: 30 }} />,
      variante: 'hiddenLeft',
    },
    {
      titulo: 'Transmisiones',
      path: '/transmisiones',
      icono: <LiveTvIcon sx={{ fontSize: 30 }} />,
      variante: 'hiddenRight',
    },
  /*   {
      titulo: 'Calendario',
      path: '/calendario',
      icono: <CalendarMonthIcon sx={{ fontSize: 30 }} />,
      variante: 'hiddenLeft',
    }, */
  ];

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #06437c, #0a2239)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        pt: 4,
        pb: 8,
      }}
    >
      {/* Logo y título */}
      <Box sx={{ textAlign: 'center' }}>
        <img
          src={logo}
          alt="Logo"
          style={{ width: 100, height: 100, objectFit: 'contain' }}
        />
        <Typography
          variant="h6"
          sx={{ mt: 1.5, color: 'white', fontWeight: 'bold' }}
        >
          ¡Bienvenido!
        </Typography>
      </Box>

      {/* Tarjetas animadas */}
      <Box sx={{ width: '100%', mt: 3 }}>
        {tarjetas.map((card, index) => (
          <motion.div
            key={card.titulo}
            custom={index}
            initial={card.variante}
            animate="visible"
            variants={cardVariants}
          >
            <Card
              sx={{
                width: '90%',
                maxWidth: 380,
                mx: 'auto',
                mb: 2,
                borderRadius: 3,
                px: 2,
                py: 1.5,
                boxShadow: 6,
                backgroundColor: 'white',
              }}
            >
              <CardContent>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Avatar
                    sx={{
                      bgcolor: '#06437c',
                      width: 48,
                      height: 48,
                    }}
                  >
                    {card.icono}
                  </Avatar>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, color: '#0a2239' }}
                    >
                      {card.titulo}
                    </Typography>
                    <Button
                      onClick={() => navigate(card.path)}
                      size="small"
                      sx={{
                        mt: 0.5,
                        textTransform: 'none',
                        color: '#06437c',
                        fontWeight: 'bold',
                        px: 0,
                      }}
                    >
                      Entrar →
                    </Button>
                  </Box>
                </Stack>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </Box>
    </Box>
  );
};

export default InicioLanding;
